<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="[
    'flex items-center space-x-2',
    'rounded',
    getVariantClasses(),
    getSizeClasses(),
    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
  ]"
  (click)="onClick.emit($event)"
>
  <span *ngIf="icon" class="material-icons mr-2">{{ icon }}</span>
  <ng-content></ng-content>
</button>
